import React, { useState, useRef, useEffect } from 'react';
import {
    MoreHorizontal,
    Reply,
    Pin,
    Trash2,
    CheckSquare,
    Bell,
    PinOff,
    Share2
} from 'lucide-react';

const MessageActions = ({
    message,
    isMe,
    canPin = true,
    onReply,
    onForward,
    onPin,
    onUnpin,
    onTask,
    onReminder,
    onDelete
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const handleAction = (action) => {
        action();
        setIsOpen(false);
    };

    return (
        <div className="relative inline-block text-left" ref={menuRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`p-1.5 rounded-full transition-colors ${isOpen ? 'bg-slate-200 text-slate-700' : 'hover:bg-slate-100 text-slate-400'}`}
            >
                <MoreHorizontal size={16} />
            </button>

            {isOpen && (
                <div
                    className={`absolute z-50 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none ${isMe ? 'right-0 origin-top-right' : 'left-0 origin-top-left'}`}
                    style={{ bottom: '100%', marginBottom: '0.5rem' }}
                >
                    <div className="py-1" role="menu" aria-orientation="vertical">
                        <button
                            onClick={() => handleAction(() => onReply(message))}
                            className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                            role="menuitem"
                        >
                            <Reply size={16} /> Reply
                        </button>

                        {onForward && (
                            <button
                                onClick={() => handleAction(() => onForward(message))}
                                className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                                role="menuitem"
                            >
                                <Share2 size={16} /> Forward
                            </button>
                        )}

                        {canPin && (
                            message.pinned ? (
                                <button
                                    onClick={() => handleAction(() => onUnpin(message))}
                                    className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                                    role="menuitem"
                                >
                                    <PinOff size={16} /> Unpin Message
                                </button>
                            ) : (
                                <button
                                    onClick={() => handleAction(() => onPin(message))}
                                    className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                                    role="menuitem"
                                >
                                    <Pin size={16} /> Pin Message
                                </button>
                            )
                        )}

                        <button
                            onClick={() => handleAction(() => onTask(message))}
                            className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                            role="menuitem"
                        >
                            <CheckSquare size={16} /> Create Task
                        </button>

                        <button
                            onClick={() => handleAction(() => onReminder(message))}
                            className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-slate-700 hover:bg-slate-50 hover:text-blue-600"
                            role="menuitem"
                        >
                            <Bell size={16} /> Remind Me
                        </button>

                        {isMe && (
                            <button
                                onClick={() => handleAction(() => onDelete(message))}
                                className="flex items-center gap-3 w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50"
                                role="menuitem"
                            >
                                <Trash2 size={16} /> Delete
                            </button>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default MessageActions;
